import { useEffect, useState } from 'react';

const appZoom = (w: number) => (w <= 1280 ? 0.82 : w <= 1440 ? 0.92 : w <= 1680 ? 1 : w <= 1920 ? 1.08 : 1.18);

/**
 * index.css applies html{zoom:...} per screen width, so a plain 100vh renders as
 * 100vh × zoom and overflows the visible viewport (page scrolls even when content fits).
 * Returns a CSS height equal to exactly one visible screen — use it in place of '100vh'.
 * Keep the breakpoints in sync with index.css.
 */
export function useViewportHeight(): string {
  const [zoom, setZoom] = useState(() => (typeof window !== 'undefined' ? appZoom(window.innerWidth) : 1));
  useEffect(() => {
    const onResize = () => setZoom(appZoom(window.innerWidth));
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);
  return `${100 / zoom}vh`;
}
